import React, {useState, useEffect, useRef} from 'react';
import GoogleMapContainer from '../GoogleMapContainer';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import {ILocation, ISize, ITWorkshop} from '../../../interface';

const cx = classnames.bind(style);

interface IProps {
  accord: boolean;
  mapAccordMobile: boolean;
  //dataList: ITWorkshop[] | undefined;
  manualLocation: ILocation | undefined;
  setAccord: (value: boolean) => void;
  setAccordMobile: (value: boolean) => void;
  onContactClick: (value: ITWorkshop) => void;
  country:string
}

//Google map outside layout.
function MapSection(props: IProps) {
  const {
    accord,
    mapAccordMobile,
    setAccord,
    setAccordMobile,
    //dataList,
    onContactClick,
    country
  } = props;
  const ref = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState<ISize>({
    width: 0,
    height: 0,
  });
  const [reset, setReset] = useState<boolean>();
  //Map section size is change by accordion
  useEffect(() => {
    if (ref.current) {
      setSize({
        width: ref.current.clientWidth,
        height: ref.current.clientHeight,
      });
    }
  }, [accord, mapAccordMobile]);
  return (
    <div
      id='google-map'
      className={`${cx('map-section', {
        expanded: accord,
      })} ${accord ? 'map-expanded' : ''}`}
    >
      <span
        className={`button ${cx('accord')}`}
        role='button'
        onClick={() => setAccord(!accord)}
      ></span>
      <div className={cx('inner')}>
        <div className={cx('heading')}>
          <span
            className='link back-link'
            role='link'
            onClick={() => {
              setAccordMobile(false);
              setReset(!reset);
            }}
          ></span>
          <h5>
            {country}
          </h5>
        </div>
        {/** Google map component */}
        <div className={cx('map-block')} ref={ref}>
          <GoogleMapContainer
            size={size}
            onContactClick={onContactClick}
            resetMarket={reset}
            onAccordOpen={() => setAccord(true)}
            accord={accord}
          />
        </div>
      </div>
    </div>
  );
}

export default MapSection;
